import { DialogTrigger, Input } from "@light-technology/components";
import { useEffect, useState, type ReactNode } from "react";
import { Controller, useForm } from "react-hook-form";
import { api } from "../../state/api";
import type { Webhook } from "../../state/api.types";
import { FormModal } from "../shared/FormModal";

type UpdateWebhookForm = {
  secret: string;
};

type UpdateWebhookModalProps = {
  webhook: Webhook;
  children: ReactNode;
};

export const UpdateWebhookModal = (props: UpdateWebhookModalProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const [updateWebhook, updateWebhookResult] = api.useUpdateWebhookMutation();
  const { handleSubmit, control, reset } = useForm<UpdateWebhookForm>({
    defaultValues: { secret: "" },
  });

  useEffect(() => {
    if (isOpen) {
      reset();
    }
  }, [isOpen, reset]);

  const onSubmit = handleSubmit(({ secret }) => {
    updateWebhook({ uuid: props.webhook.uuid, secret });
    setIsOpen(false);
  });

  return (
    <DialogTrigger isOpen={isOpen} onOpenChange={setIsOpen}>
      {props.children}
      <FormModal
        textTitle="What would you like to update the webhook secret to?"
        textCancel="Cancel"
        textSubmit="Update webhook"
        isLoading={updateWebhookResult.isLoading}
        onCancel={() => {
          setIsOpen(false);
        }}
        onSubmit={onSubmit}
      >
        <Controller
          control={control}
          name="secret"
          render={({ field, fieldState }) => (
            <Input
              {...field}
              type="text"
              validationBehavior="aria"
              isInvalid={fieldState.invalid}
              hint={fieldState.error?.message}
            />
          )}
        />
      </FormModal>
    </DialogTrigger>
  );
};
